import styled from "styled-components";

const DetailedPageRelatedImg = styled.img`
  height: 50px;
  width: 50px;
  object-fit: cover;
  border-radius: 50%;
`;

export default DetailedPageRelatedImg;
